"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConsent = void 0;
const react_1 = require("react");
const osano_1 = require("./osano");
// hook form of this context https://github.com/input-output-hk/gdpr-test/blob/90b6e3696b905bc5f2d17364b820ac859060db83/src/context/ConsentManagementContext.tsx
function useConsent(type) {
    var _a;
    const initialConsent = typeof Osano !== "undefined"
        ? ((_a = Osano.cm) === null || _a === void 0 ? void 0 : _a.getConsent()[type]) === osano_1.OsanoConsentDecision.ACCEPT
        : undefined;
    const [state, setState] = (0, react_1.useState)(initialConsent);
    (0, react_1.useEffect)(() => {
        const cm = typeof Osano !== "undefined" ? Osano.cm : undefined;
        if (!cm) {
            return;
        }
        setState(cm.getConsent()[type] === osano_1.OsanoConsentDecision.ACCEPT);
        const handler = (changed) => {
            if (type in changed) {
                setState(changed[type] === osano_1.OsanoConsentDecision.ACCEPT);
            }
        };
        cm.addEventListener(osano_1.OsanoEvent.CONSENT_SAVED, handler);
        return () => {
            cm.removeEventListener(osano_1.OsanoEvent.CONSENT_SAVED, handler);
        };
    }, [type]);
    return state;
}
exports.useConsent = useConsent;
